export default {
    "apartments.floors": {
        fields: {},
    },
    "apartments.investments": {},
    "apartments.buildings": {
        fields: {
            floors: ["apartments.floors"],
        },
        refs: {
            investment: "apartments.investments",
        },
    },
    "apartments.plans": {
        fields: { media: ["cms.media"] },
        refs: {
            resources_collection: ["cms.plan-resources"],
        },
        override: ["layers"],
    },
    "apartments.flats": {
        fields: {
            media: ["cms.media"],
            tags: ["cms.tags"],
        },
        refs: {
            floor: "apartments.floors",
        },
    },
};
